var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    class: ['header', 'panel', _vm._isMobile() ? 'mobile' : '']
  }, [_c('div', {
    staticClass: "logo-bar"
  }, [_c('a-row', {
    staticClass: "menu-up",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo ? _vm.logo : '/img/logo.png',
      "alt": ""
    }
  })])]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "login-btn-wrap"
  }, [_c('div', {
    staticClass: "header-avatar"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.avatarUrl,
      "alt": ""
    },
    on: {
      "click": _vm.toCenter
    }
  }), _vm.$store.state.user.info ? _c('span', [_c('span', {
    on: {
      "click": _vm.toCenter
    }
  }, [_vm._v(_vm._s(_vm.$store.state.user.info.realname))]), _c('a-divider', {
    attrs: {
      "type": "vertical"
    }
  }), _c('span', {
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v("退出")])], 1) : _c('span', [_c('span', {
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("登录")]), _c('a-divider', {
    attrs: {
      "type": "vertical"
    }
  }), _c('span', {
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v("注册")])], 1)])])])], 1)], 1), _c('div', {
    class: ['menu-bar', _vm.showMenu ? 'show' : 'hide', _vm.menuFixed ? 'menu-fixed' : ''],
    on: {
      "mouseleave": _vm.leave,
      "mouseover": _vm.over
    }
  }, [_c('t-menu', {
    staticClass: "menu",
    attrs: {
      "mode": "horizontal",
      "menu": _vm.menus
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };